import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Plus,
  CheckCircle2,
} from "lucide-react";

const Hero = () => {
  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="mx-auto grid max-w-screen-xl px-4 pb-8 pt-28 lg:grid-cols-12 lg:gap-8 lg:py-16 lg:pt-32 xl:gap-0">
        
        {/* Hero Content */}
        <div className="mr-auto place-self-center lg:col-span-7">
          
          {/* Badge */}
          <div className="mb-6 inline-flex items-center rounded-full bg-purple-50 px-4 py-2 text-sm font-medium text-purple-700 dark:bg-purple-900/30 dark:text-purple-300">
            🔗 Everything you share. One simple link.
          </div>

          {/* Title */}
          <h1 className="mb-5 max-w-2xl text-4xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl xl:text-6xl dark:text-white">
            Your entire online world,
            <br />
            in one{" "}
            <span className="text-purple-600">
              ZeedBio
            </span>{" "}
            link.
          </h1>

          {/* Description */}
          <p className="mb-6 max-w-2xl text-lg font-light leading-relaxed text-gray-500 lg:mb-8 md:text-xl dark:text-gray-400">
            Create your own beautiful bio page, add all your important links,
            and share one simple link everywhere. Connect your Instagram,
            TikTok, YouTube, WhatsApp, website, and more with ZeedBio.
          </p>

          {/* Buttons */}
          <div className="flex flex-col gap-4 sm:flex-row">
            
            <Link
              to="/register"
              className="inline-flex items-center justify-center rounded-lg bg-purple-700 px-6 py-3.5 text-center text-sm font-medium text-white shadow-lg transition duration-300 hover:bg-purple-800 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700"
            >
              Create your ZeedBio
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>

            <a
              href="#how-it-works"
              className="inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white px-6 py-3.5 text-sm font-medium text-gray-900 transition hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700"
            >
              See how it works
              <Plus className="ml-2 h-5 w-5 text-purple-600" />
            </a>

          </div>

          {/* Benefits */}
          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-gray-500 dark:text-gray-400">
            
            <span className="flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 text-purple-600" />
              No coding required
            </span>

            <span className="flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 text-purple-600" />
              Customize your page
            </span>

            <span className="flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 text-purple-600" />
              Share everywhere
            </span>

          </div>
        </div>

        {/* Hero Image */}
        <div className="hidden items-center justify-center lg:col-span-5 lg:mt-0 lg:flex">
          <div className="relative">
            
            {/* Background glow */}
            <div className="absolute -inset-6 rounded-full bg-purple-200/30 blur-3xl dark:bg-purple-900/20"></div>

            <img
              src="/images/hero.png"
              alt="ZeedBio profile page preview"
              className="relative z-10 max-h-[600px] w-auto object-contain"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;